import { useField, useFormikContext } from 'formik'
import { BrandKitSelect } from './BrandKitSelect'
import { BrandKitInlineSelect } from './BrandKitInlineSelect'
import useResponsiveDesign from 'hooks/useResponsiveDesign'
import { BrandVisualKit } from 'types'
import Styles from './Field.module.scss'

export const BrandKitInput = () => {
  const [brandVisualKitIdField, ,] = useField('brand_visual_kit_id')
  const { isMobile } = useResponsiveDesign()
  const { setValues } = useFormikContext<{ [key: string]: any }>()

  const setBrandVisualKitId = (brandKitId: number | undefined) => {
    setValues((values) => ({
      ...values,
      brand_visual_kit_id: brandKitId,
    }))
  }

  if (isMobile)
    return (
      <BrandKitInlineSelect
        onBrandKitChange={(brandKit?: BrandVisualKit) => {
          setBrandVisualKitId(brandKit?.id)
        }}
        selectedBrandKitId={brandVisualKitIdField.value}
        popoverClassName={Styles.popoverClassName}
      />
    )

  return (
    <BrandKitSelect
      onBrandKitChange={(id?: number) => {
        setBrandVisualKitId(id)
      }}
      selectedBrandKit={brandVisualKitIdField.value}
    />
  )
}
